import { render, staticRenderFns } from "./RiskSurveyPremisesDesc.vue?vue&type=template&id=0c70eb20&"
import script from "./RiskSurveyPremisesDesc.vue?vue&type=script&lang=js&"
export * from "./RiskSurveyPremisesDesc.vue?vue&type=script&lang=js&"
import style0 from "./RiskSurveyPremisesDesc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports